var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.options,"tag-placeholder":_vm.getTranslate.add_value,"multiple":true,"taggable":true,"placeholder":_vm.getTranslate.enter_a_value,"label":"text","track-by":"value"},on:{"tag":_vm.add,"input":_vm.updateValue},model:{value:(_vm.options),callback:function ($$v) {_vm.options=$$v},expression:"options"}})
}
var staticRenderFns = []

export { render, staticRenderFns }